export default {
  namespaced: true,
  hikvision_dvr: {
    section: 'hikvision',
    title: "hikvision DVR | hikvision DVR's",
    name: "nombre",
    ip: "IP",
    masterAccount: "cuenta maestra",
    tenant: "tenant",
    http_schema: "esquema http(s)",
    rtsp_schema: "esquema rtsp(s)",
    http_port: "puerto http",
    rtsp_port: "puerto rtsp",
    cameras: "camaras",
    syncSuccess: "sincronizado correctamente"
  },
};
